import React, { useState } from 'react';
import AddPopupModal from './AddPopupModal';
import PopupList from './PopupList'; // Import the new PopupList component
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const PopupManager = () => {
  const [popups, setPopups] = useState([
    {
      id: 1,
      image: 'https://via.placeholder.com/600x400?text=Popup+1',
      title: 'Special Offer',
      content: 'Get 20% off your first purchase!',
      isActive: true,
      catchphrase: 'Limited Time!',
    },
    {
      id: 2,
      image: 'https://via.placeholder.com/600x400?text=Popup+2',
      title: 'New Arrivals',
      content: 'Check out our latest perfumes',
      isActive: false,
      catchphrase: 'Fresh Scents',
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddPopup = (newPopup) => {
    setPopups([...popups, { ...newPopup, id: Date.now() }]);
    setIsModalOpen(false); // Close the modal after adding
  };

  const handleToggleActive = (id) => {
    setPopups(
      popups.map((popup) =>
        popup.id === id ? { ...popup, isActive: !popup.isActive } : popup
      )
    );
  };

  const handleDeletePopup = (id) => {
    setPopups(popups.filter((popup) => popup.id !== id));
  };

  return (
    <div>
    <ToastContainer position='top-center' theme='colored'/>
      <h2 className="text-xl font-semibold mb-4">Manage Popup Ads</h2>

      {/* Add New Popup Button */}
      <div className="flex justify-end mb-6">
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
        >
          Add New Popup
        </button>
      </div>

      {/* Current Popups */}
      <PopupList
        popups={popups}
        onToggleActive={handleToggleActive}
        onDeletePopup={handleDeletePopup}
      />

      {/* Modal for Adding New Popup */}
      {isModalOpen && (
        <AddPopupModal
          onClose={() => setIsModalOpen(false)}
          onAdd={handleAddPopup}
        />
      )}
    </div>
  );
};

export default PopupManager;